function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import Button from '../button/Button';
import { SIZE_BLOCK, STYLE_LINK } from '../button/constants';
import Divider from '../divider/Divider';
import IconButton from '../iconButton/IconButton';
import NotificationBar from '../notification/NotificationBar';
import { MODAL_BODY_PROP_TYPES, MODAL_TITLE_ID } from './constants';

var _getNotificationClasses = function _getNotificationClasses(notificationOptions) {
  var isClosing = notificationOptions.isClosing,
      shouldFloatAboveContent = notificationOptions.shouldFloatAboveContent,
      shouldAnimate = notificationOptions.shouldAnimate,
      _notificationOptions$ = notificationOptions.fullWidth,
      fullWidth = _notificationOptions$ === void 0 ? true : _notificationOptions$,
      prunedOptions = _objectWithoutProperties(notificationOptions, ["isClosing", "shouldFloatAboveContent", "shouldAnimate", "fullWidth"]);

  var classes = classNames('eds-modal__notification', {
    'eds-modal__notification--is-closing': isClosing,
    'eds-modal__notification--abs': shouldFloatAboveContent,
    'eds-modal__notification--animate': shouldAnimate,
    'eds-g-cell-md-10-12': !fullWidth,
    'eds-g-offset-md-1-12': !fullWidth,
    'eds-g-cell-12-12': fullWidth
  });
  return {
    classes: classes,
    prunedOptions: prunedOptions
  };
};

var _getNotifications = function _getNotifications(notificationOptions) {
  var notifications = null;

  if (notificationOptions) {
    var notificationOptionsList = Array.isArray(notificationOptions) ? notificationOptions : [notificationOptions];
    notifications = notificationOptionsList.map(function (notificationOption) {
      var _getNotificationClass = _getNotificationClasses(notificationOption),
          classes = _getNotificationClass.classes,
          prunedOptions = _getNotificationClass.prunedOptions;

      var key = notificationOption.children;

      if (notificationOption.children && notificationOption.children.key) {
        key = notificationOption.children.key;
      }

      return React.createElement("span", {
        className: classes,
        key: key
      }, React.createElement(NotificationBar, prunedOptions));
    });
  }

  return notifications;
};

var Header = function Header(_ref) {
  var headerActionIconType = _ref.headerActionIconType,
      headerActionTitle = _ref.headerActionTitle,
      onHeaderAction = _ref.onHeaderAction,
      title = _ref.title,
      secondaryTitle = _ref.secondaryTitle;
  var component = null;

  if (title) {
    component = React.createElement("header", {
      className: "eds-modal__header eds-align--center-vertical"
    }, React.createElement(HeaderAction, {
      headerActionIconType: headerActionIconType,
      headerActionTitle: headerActionTitle,
      onHeaderAction: onHeaderAction
    }), React.createElement(TitleHeader, {
      title: title,
      secondaryTitle: secondaryTitle
    }));
  }

  return component;
};

var HeaderAction = function HeaderAction(_ref2) {
  var headerActionIconType = _ref2.headerActionIconType,
      headerActionTitle = _ref2.headerActionTitle,
      onHeaderAction = _ref2.onHeaderAction;
  var component = null;

  if (headerActionIconType) {
    component = React.createElement("div", {
      className: "eds-modal__secondary-header-action"
    }, React.createElement(IconButton, {
      "data-automation": "modal-header-action-button",
      "data-spec": "secondary-header-action",
      onClick: onHeaderAction,
      iconType: headerActionIconType,
      title: headerActionTitle
    }));
  }

  return component;
};

var TitleHeader = function TitleHeader(_ref3) {
  var title = _ref3.title,
      secondaryTitle = _ref3.secondaryTitle;
  var component = null;
  var secondary = null;

  if (secondaryTitle) {
    secondary = React.createElement("span", {
      className: "eds-align--center"
    }, secondaryTitle);
  }

  if (title) {
    component = React.createElement("div", {
      className: "eds-modal__title-container eds-modal__title-spacing"
    }, React.createElement("h2", {
      id: MODAL_TITLE_ID,
      className: "eds-text-bl--fixed eds-text--truncate eds-modal__title eds-text-color--grey-800",
      "data-spec": "eds-modal__title"
    }, title), React.createElement("span", {
      className: "eds-text-bs--fixed eds-text-color--grey-600"
    }, secondary), React.createElement("div", {
      className: "eds-modal__title-spacing"
    }, React.createElement(Divider, null)));
  }

  return component;
};

var Illustration = function Illustration(_ref4) {
  var illustration = _ref4.illustration;
  var component = null;

  if (illustration) {
    component = React.createElement("div", {
      className: "eds-modal__illustration"
    }, illustration);
  }

  return component;
};

var PrimaryButton = function PrimaryButton(_ref5) {
  var onPrimaryAction = _ref5.onPrimaryAction,
      primaryText = _ref5.primaryText,
      primaryType = _ref5.primaryType,
      primarySize = _ref5.primarySize,
      primaryIsLoading = _ref5.primaryIsLoading,
      primaryIsDisabled = _ref5.primaryIsDisabled;
  var component = null;
  var automationSelector = 'eds-modal__primary-button';

  if (primaryText) {
    component = React.createElement(Button, {
      onClick: onPrimaryAction,
      style: primaryType,
      disabled: primaryIsDisabled,
      "data-spec": automationSelector,
      "data-automation": automationSelector,
      isLoading: primaryIsLoading,
      size: primarySize
    }, primaryText);
  }

  return component;
};

var SecondaryButton = function SecondaryButton(_ref6) {
  var onSecondaryAction = _ref6.onSecondaryAction,
      secondaryText = _ref6.secondaryText,
      secondaryType = _ref6.secondaryType,
      secondaryIsDisabled = _ref6.secondaryIsDisabled;
  var component = null;

  if (secondaryText) {
    component = React.createElement("div", {
      className: "eds-l-mar-right-4"
    }, React.createElement(Button, {
      onClick: onSecondaryAction,
      style: secondaryType,
      disabled: secondaryIsDisabled,
      "data-spec": "eds-modal__secondary-button"
    }, secondaryText));
  }

  return component;
};

var TertiaryButton = function TertiaryButton(_ref7) {
  var onTertiaryAction = _ref7.onTertiaryAction,
      tertiaryNode = _ref7.tertiaryNode;
  var component = null;

  if (tertiaryNode) {
    component = React.createElement(Button, {
      onClick: onTertiaryAction,
      style: "none",
      __containerClassName: "eds-modal__button-bar__tertiary"
    }, tertiaryNode);
  }

  return component;
};
/**
 * When there is a message to display in the button bar. returns the requisite markup.
 * When there is no message, returns null.
 *
 * @param {String} message - If null or undefined, the component is null
 * @param {Boolean} hasBlockButton
 * @param {String[]} customClassNames- Custom class names to add to the root node of this component (optional, defaults to [])
 */


var ButtonBarMessage = function ButtonBarMessage(_ref8) {
  var message = _ref8.message,
      hasBlockButton = _ref8.hasBlockButton,
      _ref8$customClassname = _ref8.customClassnames,
      customClassnames = _ref8$customClassname === void 0 ? [] : _ref8$customClassname;
  var component = null;
  var messageClasses;

  if (message) {
    messageClasses = classNames.apply(void 0, ['eds-modal__message eds-text-bs eds-text-color--grey-500'].concat(_toConsumableArray(customClassnames), [{
      'eds-modal__message--right': !hasBlockButton
    }]));
    component = React.createElement("div", {
      className: messageClasses
    }, message);
  }

  return component;
};

var ButtonBar = function ButtonBar(_ref9) {
  var primaryType = _ref9.primaryType,
      primaryText = _ref9.primaryText,
      primaryIsDisabled = _ref9.primaryIsDisabled,
      primaryIsLoading = _ref9.primaryIsLoading,
      primarySize = _ref9.primarySize,
      onPrimaryAction = _ref9.onPrimaryAction,
      secondaryType = _ref9.secondaryType,
      secondaryText = _ref9.secondaryText,
      secondaryIsDisabled = _ref9.secondaryIsDisabled,
      onSecondaryAction = _ref9.onSecondaryAction,
      title = _ref9.title,
      tertiaryNode = _ref9.tertiaryNode,
      onTertiaryAction = _ref9.onTertiaryAction,
      buttonBarMessage = _ref9.buttonBarMessage,
      shouldShowFooter = _ref9.shouldShowFooter,
      __footerContainerClassName = _ref9.__footerContainerClassName;
  var component = null;
  var hasBlockButton = primarySize === SIZE_BLOCK && !secondaryText && !tertiaryNode;
  var footerClasses = classNames('eds-modal__footer', {
    'eds-modal__footer--block': hasBlockButton
  }, __footerContainerClassName);
  var buttonBarClasses = classNames('eds-modal__button-bar', {
    'eds-modal__button-bar--with-title': title,
    'eds-modal__button-bar--with-tertiary': tertiaryNode
  });
  var primarySecondaryClasses = classNames('eds-modal__button-bar__primary-secondary', {
    'eds-align--right': !hasBlockButton,
    'eds-modal__button-bar--block': hasBlockButton
  });

  if (primaryText || shouldShowFooter) {
    component = React.createElement("div", {
      className: "eds-modal__footer-background"
    }, React.createElement("div", {
      className: footerClasses,
      "data-spec": "eds-modal__footer"
    }, React.createElement(ButtonBarMessage, {
      customClassnames: ['eds-show-down-sw', 'eds-l-pad-top-4', 'eds-align--center'],
      message: buttonBarMessage
    }), React.createElement("nav", {
      className: buttonBarClasses
    }, React.createElement("div", {
      className: primarySecondaryClasses
    }, React.createElement(SecondaryButton, {
      onSecondaryAction: onSecondaryAction,
      secondaryText: secondaryText,
      secondaryType: secondaryType,
      secondaryIsDisabled: secondaryIsDisabled
    }), React.createElement(PrimaryButton, {
      onPrimaryAction: onPrimaryAction,
      primaryText: primaryText,
      primaryType: primaryType,
      primarySize: primarySize,
      primaryIsDisabled: primaryIsDisabled,
      primaryIsLoading: primaryIsLoading
    })), React.createElement(TertiaryButton, {
      onTertiaryAction: onTertiaryAction,
      tertiaryNode: tertiaryNode
    }), React.createElement(ButtonBarMessage, {
      customClassnames: ['eds-align--center-vertical', 'eds-show-up-mn'],
      hasBlockButton: hasBlockButton,
      message: buttonBarMessage
    }))));
  }

  return component;
};

var ModalBody =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(ModalBody, _React$PureComponent);

  function ModalBody() {
    _classCallCheck(this, ModalBody);

    return _possibleConstructorReturn(this, _getPrototypeOf(ModalBody).apply(this, arguments));
  }

  _createClass(ModalBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          title = _this$props.title,
          secondaryTitle = _this$props.secondaryTitle,
          illustration = _this$props.illustration,
          headerActionIconType = _this$props.headerActionIconType,
          headerActionTitle = _this$props.headerActionTitle,
          onHeaderAction = _this$props.onHeaderAction,
          primaryType = _this$props.primaryType,
          primaryText = _this$props.primaryText,
          primarySize = _this$props.primarySize,
          primaryIsDisabled = _this$props.primaryIsDisabled,
          primaryIsLoading = _this$props.primaryIsLoading,
          onPrimaryAction = _this$props.onPrimaryAction,
          secondaryType = _this$props.secondaryType,
          secondaryText = _this$props.secondaryText,
          secondaryIsDisabled = _this$props.secondaryIsDisabled,
          onSecondaryAction = _this$props.onSecondaryAction,
          tertiaryNode = _this$props.tertiaryNode,
          notificationOptions = _this$props.notificationOptions,
          onTertiaryAction = _this$props.onTertiaryAction,
          buttonBarMessage = _this$props.buttonBarMessage,
          shouldShowFooter = _this$props.shouldShowFooter,
          __footerContainerClassName = _this$props.__footerContainerClassName;

      var notifications = _getNotifications(notificationOptions);

      return React.createElement("div", {
        className: "eds-modal__container"
      }, React.createElement(Header, {
        headerActionIconType: headerActionIconType,
        headerActionTitle: headerActionTitle,
        onHeaderAction: onHeaderAction,
        title: title,
        secondaryTitle: secondaryTitle
      }), React.createElement("main", {
        className: "eds-modal__main"
      }, React.createElement(Illustration, {
        illustration: illustration
      }), React.createElement("div", {
        className: "eds-modal__content"
      }, notifications, React.createElement("div", {
        className: "eds-modal__content__children"
      }, children), React.createElement(ButtonBar, {
        primaryType: primaryType,
        primaryText: primaryText,
        primarySize: primarySize,
        primaryIsDisabled: primaryIsDisabled,
        onPrimaryAction: onPrimaryAction,
        secondaryType: secondaryType,
        secondaryText: secondaryText,
        secondaryIsDisabled: secondaryIsDisabled,
        onSecondaryAction: onSecondaryAction,
        title: title,
        primaryIsLoading: primaryIsLoading,
        tertiaryNode: tertiaryNode,
        onTertiaryAction: onTertiaryAction,
        buttonBarMessage: buttonBarMessage,
        shouldShowFooter: shouldShowFooter,
        __footerContainerClassName: __footerContainerClassName
      }))));
    }
  }]);

  return ModalBody;
}(React.PureComponent);

_defineProperty(ModalBody, "propTypes", MODAL_BODY_PROP_TYPES);

_defineProperty(ModalBody, "defaultProps", {
  primaryType: STYLE_LINK,
  secondaryType: STYLE_LINK
});

export { ModalBody as default };